import { Snackbar } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Alert } from "@material-ui/lab";

interface IComparisonUpdateErrorAlert {
	errorId: string | null;
	setSimulationError: (value: string | null) => void;
	isRemoveComparison: boolean;
}

const ComparisonUpdateErrorAlert = (props: IComparisonUpdateErrorAlert) => {
	const { t } = useTranslation();
	const handleClose = () => {
		props.setSimulationError(null);
	};

	return (
		<Snackbar
			open={!!props.errorId}
			autoHideDuration={5000}
			onClose={handleClose}
			anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
			style={{ maxWidth: "640px" }}
		>
			<Alert
				onClose={handleClose}
				severity="error"
				variant="filled"
				onClick={(e) => e.stopPropagation()}
				style={{ color: "#762400", background: "#FEF2F1", borderRadius: "12px" }}
			>
				{t(props.isRemoveComparison ? "simulator-comparison-remove-error" : "simulator-comparison-add-error", {
					simulationId: props.errorId,
				})}
			</Alert>
		</Snackbar>
	);
};

export default ComparisonUpdateErrorAlert;
